import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { DifficultyLevel } from '../../../enums'

export class ActivitySummaryDto {
  @ApiProperty({ type: 'string' })
  id!: string
  @ApiProperty({ type: 'string' })
  title!: string
  @ApiProperty({ type: 'string' })
  typeId!: string
  @ApiPropertyOptional({ enum: ['VERY_EASY', 'EASY', 'MEDIUM', 'HARD', 'VERY_HARD'], nullable: true })
  difficulty!: DifficultyLevel | null
  @ApiPropertyOptional({ type: Number, nullable: true })
  estimatedMinutes!: number | null
}
